import a from "./_getNative.js";
import r from "./_root.js";
var t = a, e = r, o = t(e, "WeakMap"), i = o;
export {
  i as default
};
//# sourceMappingURL=_WeakMap.js.map
